import React from 'react';
import Navigation from '../../components/Home/Navigation';
import Hero from '../../components/Home/Hero';
import Features from '../../components/Home/Features';
import Pricing from '../../components/Home/Pricing';
import Reviews from '../../components/Home/Reviews';
import TrustedBy from '../../components/Home/TrustedBy';
import FAQ from '../../components/Home/FAQ';
import Footer from '../../components/Home/Footer';
// import SEO from '../../components/SEO';
import './styles.scss';

const Home = () => {
  return (
    <div className="home">
      {/* SEO Component - Currently using static meta tags in index.html
          Uncomment and configure below if you need dynamic SEO meta tags */}
      {/* <SEO
        title="SOS Dottore - Assistenza Medica H24 | Consulto Medico Online Telefonico e Video"
        description="SOS Dottore offre assistenza medica 24/7 per tutta la famiglia. Consulto medico telefonico e in videochiamata, specialisti a tariffe agevolate, oltre 500 strutture convenzionate. A partire da €4,90/mese."
        keywords="sos dottore, assistenza medica h24, consulto medico online, medico telefonico, videochiamata medico, telemedicina"
        canonical="https://sosdottore.com/"
        ogImage="https://sosdottore.com/web-app-manifest-512x512.png"
        ogUrl="https://sosdottore.com/"
      /> */}
      <Navigation />
      <Hero />
      <Features />
      <Pricing />
      <Reviews />
      <TrustedBy />
      <FAQ />
      <Footer />
    </div>
  );
};

export default Home;
